/* Renueva el token

Autor: Benjamín León
Fecha: 2025-03-30
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlRenewToken } from './connectionData.tsx'

const useRenewToken = () => {
  const [errorRenewToken, setErrorRenewToken] = useState<string | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const renewToken = async (email: string) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlRenewToken()
      const res = await customPost<{ token: string }>(apiUrl, email)
      setErrorRenewToken(null)

      return res.token
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorRenewToken(err.message)
      } else {
        setErrorRenewToken('An unknown error occurred')
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorRenewToken, loadingPost, renewToken }
}
export default useRenewToken
